import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { usePortalNav } from "../context/PortalNavContext";
import type { PortalNavigate } from "../context/PortalNavContext";

export type { PortalNavigate, PortalNavigateOptions } from "../context/PortalNavContext";

/**
 * Navigation for client pages: `usePortalNav() ?? useNavigate()`.
 *
 * Inside the consultant read-through, PortalNavContext prefixes client paths
 * with /consultant/clients/:orgId/portal; everywhere else this is plain
 * react-router navigation. Pages always pass client paths ("/documents").
 */
export function usePortalNavigate(): PortalNavigate {
  const portal = usePortalNav();
  const navigate = useNavigate();
  return useMemo<PortalNavigate>(() => {
    if (portal) return portal;
    return (to, options) => navigate(to, options?.replace ? { replace: true } : undefined);
  }, [portal, navigate]);
}
